import connect from 'react-redux/es/connect/connect';
import { I18n } from 'react-redux-i18n';

import ClassManagement from '../components/ClassManagement';
import * as userDetailsActions from '../../../../../actions/UserDetailsActions';
import * as mainActions from '../../../../../actions';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        create: async (data) => {
            await userDetailsActions.createSecurityClass(data);
            dispatch(userDetailsActions.getCommonSecurity());
        },
        edit: async (data) => {
            await userDetailsActions.editSecurityClass(data);
            dispatch(userDetailsActions.getCommonSecurity());
        },
        showError: ({ title, description }) => {
            dispatch(
                mainActions.showMessageBoxBasedOnData(
                    undefined, 
                    true,
                    title,
                    description, 
                    undefined,
                    I18n.t('OK'),
                )
            );
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassManagement);

